import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { S } from './AddCustomerUserModal.style';
import { AddCustomerUserForm } from '../AddCustomerUserForm/AddCustomerUserForm';

type Props = {
  chosenClientId: string;
  open: boolean;
  onCancel: () => void;
};

export const AddCustomerUserModal: React.FC<Props> = (props) => {
  if (!props.open) {
    return <></>;
  }

  return (
    <Dialog.Root open={props.open}>
      <Dialog.Portal>
        <S.Overlay>
          <S.Content>
            <S.ContentHeader>
              <Dialog.Title asChild>
                <S.H4>Skapa ny kund-användare</S.H4>
              </Dialog.Title>

              <S.CloseButton asChild onClick={props.onCancel}>
                <S.Icon src="Close" width={20} height={20} />
              </S.CloseButton>
            </S.ContentHeader>

            <AddCustomerUserForm
              onCancel={props.onCancel}
              chosenClientId={props.chosenClientId}
            />
          </S.Content>
        </S.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
